<template>
  <CommingSoon />
</template>

<script>
import CommingSoon from './components/CommingSoon.vue'

export default {
  name: 'App',
  components: {
    CommingSoon
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>
